module.exports = {
  __depends__: [ require(205) ],
  __init__: ['bpmnReplacePreview'],
  bpmnReplacePreview: [ 'type', require(72) ]
};
